var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLiveViewer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FAFAFA"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.684 4c3.786 0 6.403 1.833 7.854 5.5l-.124.301C15.941 13.267 13.364 15 9.684 15c-3.68 0-6.22-1.733-7.618-5.199L1.949 9.5C3.319 5.833 5.899 4 9.684 4m.06 1.986c-1.885 0-3.41 1.556-3.41 3.476s1.525 3.475 3.41 3.475c1.883 0 3.41-1.556 3.41-3.475 0-1.92-1.527-3.476-3.41-3.476m0 1.68c.992 0 1.798.822 1.798 1.834s-.806 1.834-1.799 1.834c-.993 0-1.8-.822-1.8-1.834s.807-1.834 1.8-1.834",
    transform: "translate(-87 -271) translate(16 261) translate(68 10) translate(3)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLiveViewer);
export default __webpack_public_path__ + "static/media/ic_live_viewer.f013b028e59c72dfa3f4f188b42aa750.svg";
export { ForwardRef as ReactComponent };